import clsx from 'clsx';

function Toggle({ checked, onChange, disabled }) {
  return (
    <button
      type="button"
      onClick={() => !disabled && onChange?.(!checked)}
      disabled={disabled}
      className={clsx(
        'relative w-9 h-5 rounded-full transition-colors flex-none',
        checked ? 'bg-orange' : 'bg-[#E5E0D5]',
        disabled && 'opacity-60 cursor-not-allowed'
      )}
    >
      <span
        className="absolute top-0.5 w-4 h-4 rounded-full bg-white shadow"
        style={{ insetInlineStart: checked ? 18 : 2, transition: 'inset-inline-start .15s' }}
      />
    </button>
  );
}

export function PermissionMatrix({ groups, selected, onToggle, disabled }) {
  if (!Array.isArray(groups) || !groups.length) {
    return <div className="text-ink-3 text-center py-10 text-sm">لا توجد صلاحيات لعرضها</div>;
  }

  function isOn(perm) {
    if (selected === 'ALL' || selected?.includes?.('*')) return true;
    return selected?.includes?.(perm);
  }

  return (
    <div className="space-y-5">
      {groups.map((g) => {
        const perms = g.perms || g.permissions || [];
        const onCount = perms.filter((p) => isOn(p.key || p.k || p)).length;
        return (
          <div key={g.name || g.label}>
            <div className="flex items-center gap-2 mb-2">
              <h4 className="m-0 text-[13px] font-bold">{g.name || g.label}</h4>
              <div className="flex-1 h-px bg-line" />
              <span className="text-[10.5px] text-ink-3">
                {onCount}/{perms.length}
              </span>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {perms.map((p) => {
                const key = p.key || p.k || p;
                const label = p.label || p.l || p.name || key;
                const enabled = isOn(key);
                return (
                  <label
                    key={key}
                    className={clsx(
                      'flex items-center gap-2.5 p-2.5 rounded-[10px] border border-line transition-colors',
                      enabled ? 'bg-[#FFFCF5]' : 'bg-white',
                      disabled ? 'cursor-not-allowed opacity-80' : 'cursor-pointer hover:bg-paper-2'
                    )}
                  >
                    <Toggle
                      checked={enabled}
                      onChange={() => onToggle?.(key)}
                      disabled={disabled}
                    />
                    <div className="flex-1 min-w-0">
                      <div className="text-[12.5px] font-semibold">{label}</div>
                      <div className="text-[10.5px] text-ink-3 font-mono truncate">{key}</div>
                    </div>
                  </label>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
